import * as React from 'react';

var _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgArc = function SvgArc(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 48 48"
    }, props), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_1_2)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_1_2)",
        d: "M48 24C48 10.745 37.255 0 24 0S0 10.745 0 24s10.745 24 24 24 24-10.745 24-24"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_1_2)",
        d: "M23.993 8.4c3.957 0 7.473 3.428 9.903 9.651 1.264 3.237 2.194 7.083 2.745 11.267.05.374.091.753.134 1.132q.023.037.02.063c.001.009.324 2.03.392 5.537h-.036c-.48-.394-6.144-4.845-15.533-3.556.141-1.589.336-3.135.588-4.617l.04-.224c3.683-.111 6.906.317 9.378.877l-.026-.177c-.508-3.164-1.258-6.06-2.224-8.536-1.58-4.048-3.642-6.562-5.38-6.562-1.739 0-3.801 2.514-5.381 6.562-.383.979-.731 2.023-1.043 3.124a47 47 0 0 0-1.102 4.936 62 62 0 0 0-.81 8.173H10.8c.224-6.77 1.372-13.087 3.29-17.999 2.43-6.224 5.947-9.651 9.903-9.651"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1_2",
        x1: 24,
        x2: 24,
        y1: 0,
        y2: 48,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#000B24"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.743,
        stopColor: "#052950"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#416D91"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_1_2",
        x1: 23.994,
        x2: 46.193,
        y1: 8.4,
        y2: 54.921,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_1_2"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h48v48H0z"
    })))));
};

export { SvgArc as ReactComponent };
//# sourceMappingURL=Arc.svg.es.js.map
